var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3769_4509)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00003 1.56244C3.54927 1.56244 1.56253 3.54918 1.56253 5.99994C1.56253 8.4507 3.54927 10.4374 6.00003 10.4374C8.45079 10.4374 10.4375 8.4507 10.4375 5.99994C10.4375 3.54918 8.45079 1.56244 6.00003 1.56244ZM0.437531 5.99994C0.437531 2.92786 2.92795 0.437439 6.00003 0.437439C9.07211 0.437439 11.5625 2.92786 11.5625 5.99994C11.5625 9.07202 9.07211 11.5624 6.00003 11.5624C2.92795 11.5624 0.437531 9.07202 0.437531 5.99994Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.4375C6.31066 2.4375 6.5625 2.68934 6.5625 3V5.65236L8.25156 6.49688C8.52942 6.63582 8.64205 6.97369 8.50312 7.25156C8.36418 7.52942 8.02631 7.64205 7.74844 7.50312L5.74844 6.50312C5.55788 6.40783 5.4375 6.21306 5.4375 6V3C5.4375 2.68934 5.68934 2.4375 6 2.4375Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3769_4509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredStatus);
export default __webpack_public_path__ + "static/media/expired-status.0ce7fa7f55428c0e1ba8077eb49ab833.svg";
export { ForwardRef as ReactComponent };